// Keep this pattern in sync with the server C# regex for survey template identifiers.
export const identifierPattern = /^[\p{L}\p{M}\p{N}_.() -]+$/u;

/**
 * Returns a user-visible error string if the identifier is invalid, or null if it is valid.
 * @param label  The human-readable field name used in the error message, e.g. "Step identifier".
 */
export function getIdentifierValidationError(identifier: string | null | undefined, label: string): string | null {
    if (identifier == null || identifier.trim() === '') {
        return `${label} is required.`;
    }

    if (!identifierPattern.test(identifier)) {
        return `${label} "${identifier}" is invalid. It can only contain letters, numbers, spaces, periods, underscores, hyphens, and parentheses.`;
    }
    if (identifier === "." || identifier === "..") {
        return `${label} "${identifier}" is invalid. It cannot be '.' or '..'.`;
    }
    return null;
}
